import { ValidationMessages } from 'shared/models/Validation';
import * as yup from 'yup';

export const passwordValidationSchema = yup.string().required(ValidationMessages.REQUIRED)
    .min(8, 'Password length must be at least 8 characters')
    .matches(/[a-z]+/, 'Password must include at least one lower case letter')
    .matches(/[A-Z]+/, 'Password must include at least one upper case letter')
    .matches(/\d+/, 'Password must include at least one digit')
    .matches(/\W+/, 'Password must include at least one special character');
